import { useThemeTypePreference } from '@src/hooks/useThemeTypePreference';
import { ThemeProvider } from '@src/styles/ThemeProvider';
import { logger, usePreferredTheme } from '@talos/kyoko';
import { useRouteError } from 'react-router-dom';
import styled from 'styled-components';
import { ErrorBoundaryDisplay } from './ErrorBoundaryDisplay';

const RouterErrorBoundaryWrapper = styled.div`
  width: 100vw;
  width: 100dvw;
  height: 100vh;
  height: 100dvh;
  background: ${({ theme }) => theme.backgroundContent};
`;

/** React Router-level Error Boundary (not caught by any internal ErrorBoundary) */
export const ErrorBoundaryRouted = () => {
  const { themeType } = useThemeTypePreference();
  const preferredTheme = usePreferredTheme('DarkTalosTheme', themeType);
  const error = useRouteError();
  logger.error(error as Error);
  return (
    <ThemeProvider theme={preferredTheme}>
      <RouterErrorBoundaryWrapper>
        <ErrorBoundaryDisplay
          onReload={() => {
            window.location.reload();
          }}
        />
      </RouterErrorBoundaryWrapper>
    </ThemeProvider>
  );
};
